import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 radius-7" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-sm-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
      href: "#",
      "data-bs-toggle": "modal",
      "data-bs-target": "#CreateUserModal"
    }, [
      /*#__PURE__*/_createTextVNode(" Criar novo usuário "),
      /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" })
    ])
  ])
], -1)
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-25 mt-10" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " Nome "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Email "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Telefone "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Status "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
    }, " Editar "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
    }, " Deletar ")
  ])
], -1)
const _hoisted_7 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-edit lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeleteUserModal = _resolveComponent("DeleteUserModal")!
  const _component_CreateUserModal = _resolveComponent("CreateUserModal")!
  const _component_UpdateUserModal = _resolveComponent("UpdateUserModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DeleteUserModal),
    _createVNode(_component_CreateUserModal),
    _createVNode(_component_UpdateUserModal),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAllUsersList, (value, key) => {
                return (_openBlock(), _createElementBlock("tr", { key: key }, [
                  _createElementVNode("th", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(value.name), 1)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(value.email), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(value.phone), 1),
                  _createElementVNode("td", _hoisted_12, [
                    (value.active === 1 || value.active === true)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Ativo"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_14, "Inativo"))
                  ]),
                  _createElementVNode("td", _hoisted_15, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.setCurrentUpdateUser(value)),
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#UpdateUserModal",
                      class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                      type: "button"
                    }, _hoisted_18, 8, _hoisted_16)
                  ]),
                  _createElementVNode("td", _hoisted_19, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.setCurrentDeleteUser(value)),
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#DeleteUserModal",
                      class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                      type: "button"
                    }, _hoisted_22, 8, _hoisted_20)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}